import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-game-log',
  templateUrl: './game-log.component.html',
  styleUrls: ['./game-log.component.scss']
})
export class GameLogComponent {

  public data: any = { match: "exact" };
  public load: any = false;
  public items: any = [];
  public games: any = []
  public statistic: any = {};
  public page_nat: any = { page_nat: [] };
  private selected_company: any = null;

  // --- Read-through helpers (all client-side over the loaded page) ---
  public quickSearch: string = '';
  public statusFilter: string = 'all';   // 'all' | '1' | '2' | '9'
  public resultFilter: string = 'all';   // 'all' | 'win' | 'loss' | 'bonus'
  public sortKey: string = '';
  public sortDir: 'asc' | 'desc' = 'desc';
  public copiedValue: string = '';

  public columnDefs = [
    { key: 'no', label: 'No' },
    { key: 'player', label: 'Player' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'game', label: 'Game' },
    { key: 'game_name', label: 'Game Name' },
    { key: 'player_game_id', label: 'Player Game ID' },
    { key: 'transaction_id', label: 'Transaction ID' },
    { key: 'round_id', label: 'Round ID' },
    { key: 'match', label: 'Match / Event' },
    { key: 'remark', label: 'Remark' },
    { key: 'bet', label: 'Bet' },
    { key: 'winloss', label: 'Winloss' },
    { key: 'bonus', label: 'Bonus/Jackpot' },
    { key: 'wb_after', label: 'Wallet After Bet' },
    { key: 'status', label: 'Status' },
    { key: 'create_on', label: 'Create On' },
  ];
  public visibleColumns: any = {};
  public showColumnPicker = false;

  // A focused, readable default column set — the rest are opt-in via the picker.
  private defaultVisibleKeys = ['no', 'player', 'game', 'match', 'remark', 'bet', 'winloss', 'bonus', 'wb_after', 'status', 'create_on'];

  // Per-row expand state for the sportsbook match-detail drawer (keyed by bet id).
  public expanded: any = {};

  get visibleColCount(): number {
    return this.columnDefs.filter(c => this.visibleColumns[c.key]).length;
  }

  col(key: string): boolean {
    return !!this.visibleColumns[key];
  }

  constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.selected_company = this.http.getStaticSelectedCompany();
    this.columnDefs.forEach(c => this.visibleColumns[c.key] = this.defaultVisibleKeys.indexOf(c.key) !== -1);

    let queryParams = this.activatedRoute.snapshot.queryParams;
    let available = false;
    if (queryParams.page_no) {
      this.data.page_no = queryParams.page_no;
      available = true;
    }
    if (queryParams.date_from) {
      this.data.date_from = queryParams.date_from;
      available = true;
    }
    if (queryParams.date_to) {
      this.data.date_to = queryParams.date_to;
      available = true;
    }
    if (queryParams.code) {
      this.data.code = queryParams.code;
      available = true;
    }
    if (queryParams.mobile) {
      this.data.mobile = queryParams.mobile;
      available = true;
    }
    if (queryParams.match) {
      this.data.match = queryParams.match;
      available = true;
    }
    if (queryParams.game_id) {
      this.data.game_id = queryParams.game_id;
      available = true;
    }
    if (queryParams.date_mode) {
      this.data.date_mode = queryParams.date_mode;
    }

    if (queryParams.is_promo) {
      this.data.is_promo = queryParams.is_promo;
    }

    if (available) {

      if (this.data.date_from && this.data.date_to && this.data.date_from > this.data.date_to) {
        [this.data.date_from, this.data.date_to] = [this.data.date_to, this.data.date_from];
      }

      if (!this.data.date_from || !this.data.date_to) {
        let date = new Date();
        if (!this.data.date_from) this.data.date_from = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T00:00"
        if (!this.data.date_to) this.data.date_to = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T23:59"
      }

      this.filter(queryParams.page_no ? queryParams.page_no : 1)
    } else {
      let date = new Date();
      this.data.date_from = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T00:00"
      this.data.date_to = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T23:59"
    }

    this.init()
  }

  async init() {
    let y: any = await this.http.post("/admin/integrated-game/get-games");
    this.games = y.games;
  }

  async filter(page_no = 1) {

    this.load = true;

    if (page_no) {
      this.data.page_no = page_no;
    }

    const payload = { ...this.data };
    delete payload.date_mode;

    let y: any = await this.http.post("/admin/integrated-game/game-log", payload);

    if (y.status && y.items) {
      this.items = y.items;
    }

    if (y.status) {
      this.statistic = y.total_summary;
      this.page_nat = y.page_nat;

      const queryParams = { ...this.data };
      delete queryParams.user_uuid;
      delete queryParams.company_uuid;

      this.router.navigate(['/lo', this.selected_company, 'game-log'], { queryParams: queryParams, replaceUrl: true });

    } else {
      this.statistic = { total_bet: 0, total_winloss: 0, total_bonus: 0 };
      this.page_nat = { current_page: 1, page_limit: 200 };
    }

    this.load = false;

  }

  statusUpdate(status) {
    switch (status) {
      case 1:
        return "Completed";
      case 2:
        return "Pending";
      case 9:
        return "Canceled"
    }
    return "" + status;
  }

  // ---- Read-through layer: search / status / result filter + sort, over the loaded page ----

  get displayItems(): any[] {
    let rows = this.items as any[];

    if (this.statusFilter !== 'all') {
      const s = parseInt(this.statusFilter, 10);
      rows = rows.filter(r => r.status == s);
    }

    if (this.resultFilter !== 'all') {
      rows = rows.filter(r => {
        const gross = parseFloat(r.winloss ?? 0);
        const bet = parseFloat(r.bet ?? 0);
        const bonus = parseFloat(r.bonus ?? 0);
        const net = this.netOf(r);
        // Filter on NET (payout - stake): a sportsbook loss has gross payout 0 but a
        // genuine negative net, so gross-only filtering hid every PINNACLE loss.
        if (this.resultFilter === 'win') return net > 0;
        if (this.resultFilter === 'loss') return net < 0;
        if (this.resultFilter === 'bonus') return bonus > 0 || (gross > 0 && bet == 0);
        return true;
      });
    }

    const q = (this.quickSearch || '').trim().toLowerCase();
    if (q) {
      rows = rows.filter(r =>
        ('' + (r.code ?? '')).toLowerCase().includes(q) ||
        ('' + (r.mobile ?? '')).toLowerCase().includes(q) ||
        ('' + (r.game_name ?? '')).toLowerCase().includes(q) ||
        ('' + (r.platform ?? '')).toLowerCase().includes(q) ||
        ('' + (r.supplier_game_name ?? '')).toLowerCase().includes(q) ||
        ('' + (r.player_username ?? '')).toLowerCase().includes(q) ||
        ('' + (r.transaction_id ?? '')).toLowerCase().includes(q) ||
        ('' + (r.round_id ?? '')).toLowerCase().includes(q)
      );
    }

    if (this.sortKey) {
      const key = this.sortKey;
      const numeric = ['bet', 'winloss', 'bonus', 'wallet_balance', 'status'].indexOf(key) !== -1;
      const dir = this.sortDir === 'asc' ? 1 : -1;
      rows = rows.slice().sort((a, b) => {
        let av = a[key], bv = b[key];
        if (key === 'create_on') { av = new Date(av).getTime(); bv = new Date(bv).getTime(); }
        else if (key === 'winloss') { av = this.netOf(a); bv = this.netOf(b); }  // sort on the displayed NET
        else if (numeric) { av = parseFloat(av ?? 0); bv = parseFloat(bv ?? 0); }
        else { av = ('' + (av ?? '')).toLowerCase(); bv = ('' + (bv ?? '')).toLowerCase(); }
        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
      });
    }

    return rows;
  }

  toggleSort(key: string) {
    if (this.sortKey === key) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDir = 'desc';
    }
  }

  sortIcon(key: string): string {
    if (this.sortKey !== key) return '';
    return this.sortDir === 'asc' ? '▲' : '▼';
  }

  resetView() {
    this.quickSearch = '';
    this.statusFilter = 'all';
    this.resultFilter = 'all';
    this.sortKey = '';
    this.sortDir = 'desc';
  }

  copyId(value: any) {
    const text = '' + (value ?? '');
    if (!text) return;
    try {
      if (navigator && (navigator as any).clipboard) {
        (navigator as any).clipboard.writeText(text);
      }
    } catch (e) { /* clipboard unavailable — no-op */ }
    this.copiedValue = text;
    setTimeout(() => { if (this.copiedValue === text) this.copiedValue = ''; }, 1200);
  }

  // Net win/loss from the PLAYER's perspective = payout returned (winloss) - real stake (bet).
  // The stored `winloss` column is the GROSS payout and is ~never negative (a loss is recorded
  // as payout 0 with the stake already taken), so a row must be judged on NET, not gross —
  // otherwise sportsbook losses (where bet.bet is also 0) appear as "nothing / all winning".
  netOf(item: any): number {
    if (item && item.net_winloss !== undefined && item.net_winloss !== null) {
      const n = parseFloat(item.net_winloss);
      if (Number.isFinite(n)) return n;
    }
    return (parseFloat(item?.winloss ?? 0) || 0) - (parseFloat(item?.bet ?? 0) || 0);
  }

  resultClass(item: any): string {
    if (this.isMovement(item)) {
      return item.row_type === 'withdraw' ? 'gl-withdraw' : 'gl-deposit';
    }
    const gross = parseFloat(item.winloss ?? 0);
    const bet = parseFloat(item.bet ?? 0);
    const net = this.netOf(item);
    if (gross > 0 && bet == 0) return 'gl-bonus';   // payout with no stake (bonus/jackpot/free spin)
    if (net > 0) return 'gl-playerwin';             // player won (net positive)
    if (net < 0) return 'gl-playerloss';            // player lost (net negative — incl. sportsbook losses)
    return '';
  }

  // ---- Deposit / withdraw movement rows (only present when "Include deposits" is on) ----

  // A merged feed row sourced from player_wallet (a deposit or a withdrawal), not a bet.
  isMovement(item: any): boolean {
    return item && (item.row_type === 'deposit' || item.row_type === 'withdraw');
  }

  // Signed money moved on a movement row (deposit positive, withdraw negative).
  mvAmount(item: any): number {
    return parseFloat(item?.amount ?? 0) || 0;
  }

  // Bilingual label shown in the Game column for a movement row.
  mvLabel(item: any): string {
    return item?.row_type === 'withdraw' ? '🏧 Withdraw 取款' : '💰 Deposit 存款';
  }

  // ---- Sportsbook match detail (bet.game_detail = AWC gameInfo.legs[]) ----

  // True when the row carries captured match detail (PINNACLE / sportsbook events).
  hasDetail(item: any): boolean {
    const gd = item && item.game_detail;
    return !!(gd && Array.isArray(gd.legs) && gd.legs.length > 0);
  }

  // One-line summary shown in the Match column: the first event + a leg count for parlays.
  matchSummary(item: any): string {
    if (!this.hasDetail(item)) return '';
    const legs = item.game_detail.legs;
    const first = legs[0] || {};
    const event = first.eventName || ((first.homeTeam && first.awayTeam) ? (first.homeTeam + ' vs ' + first.awayTeam) : '');
    const head = (first.sportName || item.game_detail.sportName || 'Match');
    let label = event ? (head + ': ' + event) : head;
    if (legs.length > 1) label += ' (+' + (legs.length - 1) + ' more)';
    return label;
  }

  toggleExpand(item: any) {
    if (!this.hasDetail(item)) return;
    const k = '' + (item.id ?? item.transaction_id);
    this.expanded[k] = !this.expanded[k];
  }

  isExpanded(item: any): boolean {
    return !!this.expanded['' + (item.id ?? item.transaction_id)];
  }

  // Readable selection line for one leg, e.g. "Match Handicap -> Over +4.75  @ 2.11".
  legSelection(leg: any): string {
    const parts: string[] = [];
    if (leg.marketName || leg.betType) parts.push(leg.marketName || leg.betType);
    let sel = leg.selection || '';
    if (leg.handicap !== null && leg.handicap !== undefined && leg.handicap !== '') {
      const h = parseFloat(leg.handicap);
      sel += (Number.isFinite(h) ? (' ' + (h > 0 ? '+' : '') + h) : (' ' + leg.handicap));
    }
    if (sel) parts.push(sel.trim());
    let line = parts.join(' → ');
    if (leg.odds !== null && leg.odds !== undefined) line += '  @ ' + leg.odds;
    return line.trim();
  }

  legResultClass(leg: any): string {
    const s = ('' + (leg.legStatus || '')).toUpperCase();
    if (s.indexOf('WON') !== -1 || s === 'WIN') return 'text-success';
    if (s.indexOf('LOST') !== -1 || s.indexOf('LOSE') !== -1) return 'text-danger';
    if (s.indexOf('VOID') !== -1 || s.indexOf('CANCEL') !== -1 || s.indexOf('REFUND') !== -1) return 'text-muted';
    return '';
  }

  // ---- Bet outcome badge (WIN / LOSS / REFUND / PUSH) shown on the collapsed row ----
  // A refund/void settles to NET 0 with the full stake returned, so on a bets-only log it
  // looks identical to a break-even push and the Status column shows the engine status
  // ("Completed"), not the bet result. Agents could only see "REFUNDED" by expanding the
  // legs drawer. This derives an explicit outcome — primarily from the AWC leg statuses
  // (game_detail.legs[].legStatus), falling back to NET for non-sportsbook rows — so a
  // refund is visible at a glance without expanding.
  betOutcome(item: any): { label: string; cls: string } | null {
    if (!item || this.isMovement(item)) return null;

    // Sportsbook rows carry the authoritative per-leg status from the supplier.
    if (this.hasDetail(item)) {
      const legs = item.game_detail.legs as any[];
      const norm = legs.map(l => ('' + (l?.legStatus || '')).toUpperCase());
      const known = norm.filter(s => s.length > 0);
      const isRefund = (s: string) => s.indexOf('VOID') !== -1 || s.indexOf('CANCEL') !== -1 || s.indexOf('REFUND') !== -1 || s.indexOf('PUSH') !== -1 || s.indexOf('DRAW') !== -1;
      // Every settled leg is a void/refund/push -> the whole bet was refunded.
      if (known.length > 0 && known.every(isRefund)) {
        return { label: 'REFUND 退款', cls: 'bg-info text-dark' };
      }
    }

    const gross = parseFloat(item.winloss ?? 0);
    const bet = parseFloat(item.bet ?? 0);
    const net = this.netOf(item);
    if (gross > 0 && bet == 0) return { label: 'BONUS 红利', cls: 'bg-info text-dark' };
    if (net > 0) return { label: 'WIN 赢', cls: 'bg-success' };
    if (net < 0) return { label: 'LOSS 输', cls: 'bg-danger' };
    // NET 0 with a real stake and no win/loss -> stake returned (push / refund).
    if (bet > 0) return { label: 'REFUND 退款', cls: 'bg-info text-dark' };
    return null;
  }

  sum(key: string) {
    // The Winloss column renders NET, so its visible total must sum NET too.
    if (key === 'winloss') {
      return this.displayItems.reduce((acc: any, item: any) => acc + this.netOf(item), 0);
    }
    return this.displayItems.reduce((acc: any, item: any) => acc + parseFloat(item[key] ?? 0), 0);
  }
}
